<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapMutations } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      "engine.isCohabiting",
    ]),
    questionAnswerData() {
      return this.$store.state.config.questionAnswerData.cohabitingQuestion;
    }
  },
  methods: {
    ...mapMutations([
      'goToNextPage', 'selectIsCohabiting'
    ]),
  }
};
</script>

<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="this.isCohabiting"
        class="question_image d-block d-sm-none question_image_cohabiting_single"
      ></div>
      <div v-else-if="!this.isCohabiting"
        class="question_image d-block d-sm-none question_image_cohabiting_partner"
      ></div>
    </Transition>

    <!-- show on desktop only -->
      <QuestionAnswer
        :title="questionAnswerData.answers.A"
        class='d-none d-sm-block'
        @click="selectIsCohabiting(false); goToNextPage()"
        tabindex="0"
        :imageName="questionAnswerData.images.Q1AA"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.B"
        class='d-none d-sm-block'
        @click="selectIsCohabiting(true); goToNextPage()"
        tabindex="0"
        :imageName="questionAnswerData.images.Q1AB"
      />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile'>
      <QuestionAnswer
        :title="questionAnswerData.answers.A"
        @click="selectIsCohabiting(false)"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.B"
        @click="selectIsCohabiting(true)"
      />
      <MDBBtn class="next-btn-on-mobile" @click="goToNextPage()">next</MDBBtn>
    </div>


  </QuestionPage>
</template>
